import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Card,
} from 'reactstrap';
import { RegularizationRequestsModal } from './RegularizationRequestsModal.component';
import { Modal as CustomModal } from '@/components/Modal';
import { Column } from 'primereact/column';
import { isEmpty } from 'lodash';
import firebase from '../../config/firebase.config';
import { DataTable } from 'primereact/datatable';
import PulseLoader from 'react-spinners/PulseLoader';
import {
  addNotification,
  notificationStates,
} from '../../components/Notification';
import moment from 'moment';
import { regularizationActionTypes } from '@store/Regularization/Regularization.actionTypes';
import { getRegularizationReporterLabel } from '../Regulation/Regularization.helper';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { useTeamMemberDetailsForSelect as useTeamMemberPicker } from '../../hooks/useTeamMemberDetailsForSelect';
import { Table } from '@/components/Table';
import { columnsConfig } from './RegularizationRequests.config';
import styles from './RegularizationRequests.module.scss';
const database = firebase.firestore();

export const RegularizationRequestsComponent = () => {
  const teams = useSelector((state) => ({
    projects: state.team.projects,
    active: state.team.active,
    teams: state?.team?.teams,
  }));
  const user = useSelector((state) => ({
    activeTeamId: state.team.selectedTeamID,
  }));
  const { memberDetails } = useTeamMemberPicker(user.activeTeamId ?? null);
  const { activeCompany } = useSelector((state) => state.auth.profile);
  const { profile } = useSelector((state) => state.auth);
  const regularizationState = useSelector(
    (state) => state.regularization || {}
  );
  const dispatch = useDispatch();

  const [modal, setModal] = useState(false);
  const [projects, setProjects] = useState([]);
  const [taskLists, setTaskLists] = useState([]);
  const [regList, setRegList] = useState([]);
  const [, setTaskRowIndex] = useState();
  const [loading, setLoading] = useState(true);
  const [selectedData, setSelectedData] = useState(null);
  const [isApproving, setIsApproving] = useState(false);

  const getRegData = () => {
    setLoading(true);
    dispatch({
      type: regularizationActionTypes.GET_MANAGER_REQUESTS,
      payload: {
        managerId: profile.id,
        companyId: activeCompany.companyId,
      },
    });
  };

  // handle approval
  const handleApprove = async (e) => {
    e.preventDefault();
    setIsApproving(true);

    // Dispatch approve action - saga will handle validation and session creation
    dispatch({
      type: regularizationActionTypes.APPROVE_REQUEST,
      payload: {
        requestData: selectedData,
        companyId: activeCompany.companyId,
      },
    });

    toggle();
    setIsApproving(false);
    getRegData();
  };

  // Decline regulation
  const handleDecline = () => {
    dispatch({
      type: regularizationActionTypes.DECLINE_REQUEST,
      payload: {
        requestId: selectedData?.id,
        companyId: activeCompany.companyId,
        assigneeId: selectedData?.assignee,
      },
    });

    toggle();
    getRegData();
  };

  const toggle = () => {
    setModal(!modal);
  };

  const fieldIndex = (rowData, column) => {
    setTaskRowIndex(column.rowIndex + 1);
    return column.rowIndex + 1 + '';
  };
  const assigneeTempelate = (rowData) => {
    const m = memberDetails?.[rowData?.assignee];
    return m?.userName || m?.userEmailid || rowData?.assignee || '';
  };

  const ReporterTemplet = (rowData) => {
    return getRegularizationReporterLabel(rowData, memberDetails);
  };

  const timeTempelate = (rowData) => {
    return `${rowData?.taskHours}h ${rowData.taskMinutes}m`;
  };

  const ReportDateTempelate = (rowData) => {
    let dateObject = rowData?.requestDate?.toDate();
    var day = dateObject?.getDate();
    var month = dateObject?.getMonth() + 1;
    var year = dateObject?.getFullYear();

    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    let dateString = day + '-' + month + '-' + year;
    return dateString ? dateString : '';
  };

  const TaskDateTempelate = (rowData) => {
    const startTime = rowData?.startTime;
    // New format: startTime is Firestore Timestamp (UTC)
    if (startTime?.toDate) {
      const d = startTime.toDate();
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    }
    // Legacy: startTime is string "YYYY-MM-DD"
    const parts = startTime?.split?.('-') || [];
    if (parts.length !== 3) return '';
    const yeartemp = parseInt(parts[0]);
    const monthtemp = parseInt(parts[1]) - 1;
    const daytemp = parseInt(parts[2]);
    const dateObject = new Date(yeartemp, monthtemp, daytemp);
    const day = String(dateObject.getDate()).padStart(2, '0');
    const month = String(dateObject.getMonth() + 1).padStart(2, '0');
    const year = dateObject.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const actionTempelate = (rowData) => {
    if (rowData) {
      if (rowData?.status === 'Approved') {
        return <h4>Completed</h4>;
      }
      if (rowData?.status === 'Declined') {
        return <h4>Declined</h4>;
      }
      return (
        <Button
          className="request-action-btn"
          onClick={() => {
            toggle();
            setSelectedData(rowData);
          }}
        >
          Process
        </Button>
      );
    }
  };

  const projectTempelate = (rowData) => {
    return (
      teams?.projects?.length > 0 &&
      teams?.projects?.filter((a) => {
        if (a?.id == rowData?.projectId) {
          return a;
        }
      })[0]?.data?.project_name
    );
  };

  // Update local state when Redux state changes
  useEffect(() => {
    if (regularizationState.managerRequests) {
      setRegList(regularizationState.managerRequests);
      setLoading(regularizationState.loading || false);
    }
  }, [regularizationState.managerRequests, regularizationState.loading]);

  useEffect(() => {
    if (!isEmpty(teams?.active)) {
      dispatch({
        type: teamActionTypes.GET_PROJECT,
        payload: { companyId: activeCompany.companyId },
      });
      if (loading) {
        getRegData();
      }
    }
  }, [activeCompany]);

  useEffect(() => {
    {
      Object.entries(teams?.projects).map((m) => {
        !m[1]?.data?.deleted === true && projects.push(m[1]);
      });
    }
    if (projects.length !== 0) {
      database
        .collection('taskDatabase')
        .where('ProjectID', '==', projects[0].id)
        .get()
        .then((res) => {
          let lists = res?.docs?.map((r) => r?.data());
          const listId = res?.docs?.map((r) => r?.id);
          let listsWithId = [];
          for (let i = 0; i < lists.length; i++) {
            listsWithId.push({ ...lists[i], id: listId[i] });
          }
          setTaskLists(listsWithId);
        });
    }
  }, [teams?.projects]);
  return (
    <>
      <div className={styles.regularizationRequestsPage}>
        {loading ? (
          <div className="w-100 d-flex justify-content-center">
            <PulseLoader color="#4f58bb" />
          </div>
        ) : (
          <Table
            className={styles.regularizationRequestsTableContainer}
            data={regList}
            columns={columnsConfig({
              teams,
              memberDetails,
              toggle,
              setSelectedData,
            })}
          />
        )}
      </div>
      <CustomModal isVisible={modal} onClose={toggle}>
        <RegularizationRequestsModal
          onAccept={handleApprove}
          onDecline={handleDecline}
        />
      </CustomModal>
      {/* Modal for accepting or declining regularization */}
      <Modal isOpen={false} toggle={toggle} className="regulationModal">
        <ModalHeader toggle={toggle}>Process Form</ModalHeader>
        <ModalBody className="pt-2 pl-4">
          <h4>Please accept or decline this application</h4>
          <h5>Note:- Request can not be update and delete after proceed..</h5>
          <br />
          <Form onSubmit={handleApprove}>
            <Button color="primary" disabled={isApproving}>
              {isApproving ? 'Accepting...' : 'Accept'}
            </Button>
            <Button onClick={handleDecline} color="danger">
              Decline
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
